export default "__VITE_ASSET__CDYPVftg__"